/* eslint-disable react/destructuring-assignment */
import React, {useEffect} from 'react';

import {useDispatch} from 'react-redux';
// import {useRouteError} from 'react-router-dom';

import * as setupActions from '@/actions/setupActions';
import {Post} from '@/api/request';
import ErrorPageContent from '@/components/errorBoundary/ErrorPageContent';
import * as APPDATA from '@/constants/pcConstAppData';
import {consoleLog} from '@/libs/consoleHelper';

/**
 * @FIXME  remove unused code
 * @returns
 */
function ErrorPage() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setupActions.updateActiveMenu(APPDATA.ERROR_PAGE));
    return () => {};
  }, []); // notice the empty array

  // const error = useRouteError();

  // if (error) throw error;

  const sucessPostRestart = () => {
    consoleLog('sucessPostRestart');
  };

  const onClick = (e) => {
    const button = e.currentTarget.id;
    consoleLog(`${button} clicked`);
    const param = {};
    const passingValue = {};
    consoleLog(APPDATA.API.PCServiceAPI.Device.REBOOT);
    if (APPDATA.CONFIGURATION.IS_DEVELOPMENT_MODE) {
      window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
      window.location.reload();
    } else {
      switch (button) {
        case APPDATA.RESTART:
          Post(APPDATA.API.PCServiceAPI.Device.REBOOT, param, sucessPostRestart, passingValue);
          break;
        case APPDATA.RELOAD:
          window.location.reload();
          break;
        default:
          break;
      }
    }
  };
  return <ErrorPageContent onClick={onClick} />;
}

export default ErrorPage;
